import { classifyStartLine } from './startLine';

/** One count unit must have the same height across every compared player. */
export function startLineChartPeak(angles: (number | null)[]): number {
  const counts = new Map<string, number>();
  let peak = 1;
  for (const angle of angles) {
    if (angle === null || !Number.isFinite(angle)) continue;
    const category = classifyStartLine(angle);
    const count = (counts.get(category) ?? 0) + 1;
    counts.set(category, count);
    peak = Math.max(peak, count);
  }
  return peak;
}
